import i18next from 'i18next';

export const isCurrentLanguageFrench = () => i18next.language === 'fr';
